import { useState } from "react";
import Modal from "../../../components/common/modal/Modal";
import ButtonComponent from "../../../components/common/button/Button";
import './UploadExcelModal.css';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import ExcelLogo from '../../../assets/272697_excel_icon.png'
import { IconButton } from '@mui/material';
import { Delete } from '@mui/icons-material';
import { styled } from '@mui/material/styles';
import Button from '@mui/material/Button';
import { fileUploadBuyerEndpoint, fileUploadSupplierEndpoint } from "../../../common/endpoints";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { postFileUpload } from "../../../redux/actions/FileUploadSlice";
import CircularProgress from '@mui/material/CircularProgress';

const VisuallyHiddenInput = styled('input')({
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    height: 1,
    overflow: 'hidden',
    position: 'absolute',
    bottom: 0,
    left: 0,
    whiteSpace: 'nowrap',
    width: 1,
});

const UploadExcelModal = ({ openUploadModal, handleCloseUploadModal, onSuccessFileUpload }) => {
    const [xlDetails, setXLDetails] = useState({});
    const [fileName, setFileName] = useState('');
    const [showError, setShowError] = useState("");
    const [data, setData] = useState(null);
    const [fileOverviewDetails, setFileOverviewDetails] = useState({});
    const userEmail = localStorage.getItem("userEmail");
    const selectedRegion = useSelector((state) => state.setRegionPlantStore.selectedRegion);
    const dispatch = useDispatch();

    const handeDeleteIcon = () => {
        setData(null);
        setFileName('');
        getFileDetails('', {});
        setShowError('');
    }

    const handleFileUpload = (event) => {
        clearFileDetails();
        const file = event?.target?.files[0];
        const formData = new FormData();
        formData.append("file", file);
        const allowedTypes = [
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // .xlsx
            "application/vnd.ms-excel" // .xls
        ];
        if (!file) {
            setShowError("No file selected")
            return;
        }

        if (file && allowedTypes.includes(file.type)) {
            const fileSizeInMB = file.size / (1024 * 1024);
            if (fileSizeInMB > 5) {
                setData(null);
                setFileName('');
                getFileDetails('', {});
                setShowError("File size exceeds 5MB. Please upload a smaller file.");
                return;
            }
            for (let pair of formData.entries()) {
                setData(pair[1]);
                setFileName(file.name)
                getFileDetails(file.name, formData);
            }
        } else {
            setShowError('Please upload a .xls or .xlsx file.');
        }
        event.target.value = "";
    }

    const onClickCancel = () => {
        clearFileDetails()
        handleCloseUploadModal();
    }
    function arrayBufferToJson(buffer) {
        const text = new TextDecoder("utf-8").decode(buffer);
        return JSON.parse(text);
    }
    const onClickSave = async () => {
        const roleDetails = localStorage.getItem("userRole");
        const endpointMap = {
            "Supplier Admin": fileUploadSupplierEndpoint,
            "Supplier Planner": fileUploadSupplierEndpoint,
            "Global Planner": fileUploadBuyerEndpoint,
            "App Admin": fileUploadBuyerEndpoint,
            "Regional Planner": fileUploadBuyerEndpoint,
            "Global Viewer": fileUploadBuyerEndpoint,
            "Regional Viewer": fileUploadBuyerEndpoint,
        };
        const selectedEndpoint = endpointMap[roleDetails];
        try {
            const responsePostFileUpload = await dispatch(postFileUpload({
                dynamicEndpoint: `${selectedEndpoint}/${userEmail}`,
                data: xlDetails,
                contentType: "multipart/form-data",
                responseType: "arraybuffer",
                headers: {
                    withCredentials: true
                },
                // 👉 add params conditionally
                ...(["Regional Planner"].includes(roleDetails) && {
                    params: {
                        region: selectedRegion
                    }
                })
            }));
            if (responsePostFileUpload?.meta?.requestStatus === "fulfilled") {
                const buffer = responsePostFileUpload.payload;

                if (buffer && buffer.byteLength > 0) {
                    setFileOverviewDetails(buffer);   // error file
                } else {
                    toast.success("File Uploaded Successfully", { autoClose: 2000 });
                    onClickCancel();
                    onSuccessFileUpload();
                }

            } else {
                try {
                    const errorBuffer = responsePostFileUpload?.payload;
                    const errorJson = arrayBufferToJson(errorBuffer);
                    toast.error(errorJson.errorMessage || "Upload failed", {
                        autoClose: 2000,
                    });
                } catch (e) {
                    toast.error("Upload failed", { autoClose: 2000 });
                }
            }
        } catch (error) {
            console.error('API error:', error);
            toast.error(error, {
                autoClose: 2000,
            });
        }
    }
    const getFileDetails = (fileName, formData = {}) => {
        setFileName(fileName);
        setXLDetails(formData);
    }

    const clearFileDetails = () => {
        setData(null);
        setFileName('');
        getFileDetails('', {});
        setShowError("");
        setFileOverviewDetails({})
    }

    const handleDownloadErrorFile = () => {
        // const binaryString = fileOverviewDetails;

        const blob = new Blob([fileOverviewDetails], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });

        const url = window.URL.createObjectURL(blob);

        const a = document.createElement('a');
        a.href = url;
        a.download = 'Error_File';
        document.body.appendChild(a);
        a.click();

        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
    };


    return (
        <div>
            <Modal
                className="UploadExcelModal_cls"
                open={openUploadModal}
                handleClose={onClickCancel}
                title="Upload File"
                fullWidth={"lg"}
                action={
                    <UploadModalFooter
                        onClickCancel={onClickCancel}
                        onClickSave={onClickSave}
                        getFileDetails={getFileDetails}
                        fileName={fileName}
                    />
                }
                content={
                    <UploadModalContent
                        getFileDetails={getFileDetails}
                        handeDeleteIcon={handeDeleteIcon}
                        handleFileUpload={handleFileUpload}
                        fileName={fileName}
                        showError={showError}
                        data={data}
                        handleDownloadErrorFile={handleDownloadErrorFile}
                        fileOverviewDetails={fileOverviewDetails}
                    />
                }
            />
        </div>
    )
}

const UploadModalFooter = ({ onClickCancel, onClickSave, fileName }) => {
    const stateSelector = useSelector((state) => state);
    return (
        <div className='btn-wrapper' style={{ display: 'flex', gap: 10 }}>
            <ButtonComponent
                label="Close"
                type="primary"
                maxWidth="80px"
                onClick={onClickCancel}
            />
            <ButtonComponent
                label="Upload"
                type="secondary"
                maxWidth="100px"
                disabled={!fileName || stateSelector?.FileUploadSlice?.loading}
                onClick={onClickSave}
            />
        </div>
    );
};
const UploadModalContent = ({ handleFileUpload, fileName, showError, handeDeleteIcon, data, errorLineItems, handleDownloadErrorFile, fileOverviewDetails }) => {
    const stateSelector = useSelector((state) => state);
    return (
        stateSelector?.FileUploadSlice?.loading ?
            <span style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                <CircularProgress size={36} />
            </span>
            :

            <div className='uploadModalContent_cls'>
                <div className="file-upload-container">
                    <p className="font-size">Upload the file for processing</p>
                    <Button
                        component="label"
                        variant="contained"
                        tabIndex={-1}
                        startIcon={<UploadFileIcon />}
                        style={{ backgroundColor: '#000', width: 150, height: 30, textTransform: 'none', color: '#FFF' }}
                    >
                        Upload File
                        <VisuallyHiddenInput
                            type="file"
                            accept=".xls,.xlsx"
                            onChange={handleFileUpload}
                        />
                    </Button>
                    {showError && <p style={{ color: 'red' }}>{showError}</p>}
                    <p className="font-size">File should be in '.xls' or '.xlsx' format</p>
                    <p className="font-size">Max file size that can be uploaded is 5MB</p>
                    {data && (
                        <div className="file-container">
                            <img style={{ paddingTop: "10px" }} src={ExcelLogo} alt='logo' width={20} height={20} />
                            <span className="font-size" style={{ paddingTop: "10px" }}>{fileName}</span>
                            <IconButton onClick={handeDeleteIcon}>
                                <Delete />
                            </IconButton>
                        </div>
                    )}
                </div>
                {fileName && fileOverviewDetails && fileOverviewDetails.byteLength > 0 && <div className="file_overview_cls">
                    <p>File contains error(s) please check and re-upload.</p>
                    <div>
                        <span className="viewDetailsErrorText">Click here to view the details for the error line items</span>
                        <div className="flex-items-row error-line-items-container" onClick={handleDownloadErrorFile}>
                            <img src={ExcelLogo} alt='logo' width={20} height={20} />
                            <span>{fileName}</span>
                        </div>
                    </div>
                </div>}
                {fileName && !fileOverviewDetails && (
                    <div className="success-message">
                        File processed successfully without errors.
                    </div>
                )}
            </div>
    );
};

export default UploadExcelModal;